import React from 'react';

export type DropEffect = 'none' | 'copy' | 'link' | 'move';

class KeyboardUtils {

    isMac : boolean;
    isSafari : boolean;

    constructor() {
        this.isMac = !!( navigator.platform ?? '' ).match( /^mac/i );
        this.isSafari = navigator.vendor?.startsWith( 'Apple' );

        // TODO: discuss if this should moved to ~src/components/base/page/PageTabPanel since the global [ESC] and [Cmd] + [S] handling is implemented there

        // prevent command/ctrl-O (browsers open dialog) as we use this to open panels in our application
        window.document.addEventListener( 'keydown', ( event : KeyboardEvent ) => {
            if ( this.cmdKey( event ) && event.code === 'KeyO' ) {
                event.preventDefault();
            }
        } );
    }

    // TODO: discuss if all keyboard actions should solved here -> configurable keys
    /**
     * Check if cmdKey has been pressed within keyboard event, based on the current platform
     * @param e
     */
    cmdKey( e : KeyboardEvent | React.KeyboardEvent<Element> | MouseEvent | React.MouseEvent<HTMLElement, MouseEvent> | React.MouseEvent<Element, MouseEvent> | undefined ): boolean {
        e = e ?? {} as KeyboardEvent;
        return this.isMac ? e.metaKey : e.ctrlKey;
    }

    /**
     * Returns the DropEffect (move/copy/link) based on platform and key-modifier
     * @param event
     */
    getDropEffect( event: DragEvent ): DropEffect {
        let retVal: DropEffect = 'move';

        if ( event.dataTransfer ) {

            // handling for macs
            if ( this.isMac ) {
                // special handling for safari as we have no key-modifiers set here
                if ( this.isSafari && event.dataTransfer.effectAllowed === 'copy' ) {
                    retVal = 'copy';
                }
                else if ( event.altKey && event.ctrlKey ) {
                    retVal = 'link';
                }
                else if ( event.altKey ) {
                    retVal = 'copy';
                }
            }
            // handling for windows (same behaviour as in explorer)
            else {
                if ( event.altKey ) {
                    retVal = 'link';
                }
                else if ( event.ctrlKey ) {
                    retVal = 'copy';
                }
            }

        }

        return retVal;
    }
}

export default new KeyboardUtils();
